import API from 'shared/api';

const api = Object.assign( API, {
  
  isWorking: 0,
  
   /*
   *  Generic function to make an API call
  */
  apiCall: function( method, endpoint, _params ){
    
    var params = typeof( _params ) != 'undefined' ? _params : {};
    
    // var worker = !params.background ? Punch.status.setWorking() : null;
    
    var worker = null;
    
    if( !params.background ){
      this.isWorking ++;
    }
    
    var controller = new AbortController();
    
    var data = typeof( params.data ) != 'undefined' ? params.data : {};
    
    var contentType = typeof( params.contentType ) != 'undefined' ? params.contentType : 'application/json';
    
    var ajax;
    
    var promise = new Promise( ( resolve, reject ) => {
      
      var headers = {
        'X-Requested-With': 'XMLHttpRequest'
      };
      
      if( contentType ){
        headers['Content-Type'] = contentType;
      }
      
      var options = {
        method: method,
        mode: 'cors',
        credentials: 'same-origin',
        headers: headers,
        redirect: 'follow',
        signal: controller.signal
      };
      
      var url = new URL( location.origin + '/api' + endpoint );

      if( method == 'GET' ){
        Object.keys( data ).forEach( key => url.searchParams.append( key, data[ key ] ) );
      }else if( contentType === 'application/json' ){
        options.body = JSON.stringify( data );
      }else{
        const formData = new FormData();
        for( var key in data ){
          formData.append( key, data[key] );
        }
        options.body = formData;
      }
      
      fetch( url, options ).then( response => {
        
        const contentType = response.headers.get("content-type");
        const isJSON = contentType && contentType.indexOf("application/json") !== -1;
                        
        if( response.ok ){
          if( !params.background ){
            if( !params.background ){
              this.isWorking --;
            }
          }
          if( isJSON ){
            resolve( response.json() );
          }else{
            resolve( response.text() );
          }
        }else{
          
          if( isJSON ){
            
            response.json().then( json => {
              if( !params.background ){
                this.isWorking --;
              }
              reject( json, response.status );
            });
            
          }else{
            
            response.text().then( text => {
              if( !params.background ){
                this.isWorking --;
              }
              reject( text, response.status );
            });
            
          }
          
        }
        
        
      }).catch( response => {
        
        if( JSON.stringify( response ) == '{}' ){
          if( !params.background ){
            this.isWorking --;
          }
          reject( response );
          return;
        }
                
        if( response.name === 'AbortError' ){
          if( !params.background ){
            this.isWorking --;
          }
          reject({ aborted: true });
          return;
        }
        
        const contentType = response.headers.get("content-type");
        const isJSON = contentType && contentType.indexOf("application/json") !== -1;
        
        if( isJSON ){
                
          response.json().then( json => {
            if( !params.background ){
              this.isWorking --;
            }
            
            if( json.loggedout ){
              window.location.reload();
            }
            
            reject( json, response.status );
            
          });
          
        }else{
                
          response.text().then( text => {
            if( !params.background ){
              this.isWorking --;
            }
            reject( text, response.status );
          });
          
        }
        
      });
            
    });
    
    promise.controller = controller;
    
    return promise;
    
  }
  
});

export default api;